import styled from 'styled-components';

export const Thead = styled.thead`
  background: #f2f2f2;
`;

export const Tt = styled.div`
  display: flex;
  color: #fff;
  align-items: center;
  background: #4b286d;
  padding: 0px 10px;
  width: 100%;
  height: 40px;
  font-weight: 700;
`;

export const Tdtotal = styled.td`
  text-align: center;
  font-weight: 600;
`;

export const TdCategoryTotal = styled.td`
  text-align: center;
  font-weight: bold;
  background: #f7f7f7;
  color: #49166d;
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
  vertical-align: middle;
`;

export const TdImp = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
  background: #f7f7f7;
  font-weight: 700;
  vertical-align: middle;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Th = styled.th`
  padding-top: 10px;
  text-align: center;
  background: #4b286d;
  color: #fff;
`;

export const Table = styled.table`
  margin: 20px 0px;
`;

export const TableContainer = styled.div`
  margin-bottom: 50px;
`;

export const CategoryTitle = styled.div`
  color: #49166d;
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

export const CategoryTotal = styled.div`
  display: flex;
  background-color: #f7f7f7;
`;

export const CategoryTotalItem = styled.div`
  flex: 1;
  color: #49166d;
  font-size: 1.2rem;
  text-align: center;
`;

export const customStyles = `
  overflow: scroll;
  height: 40%,
  max-height: 40% !important;
  width: 40%;
  position: fixed;
  margin-left: 30%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;`;

export const ModalFieldLabel = styled.div`
  font-size: 1rem;
  margin-bottom: 4px;
`;

export const CustomField = styled.div`
  margin: 20px 0px;
`;

export const ModalBottomContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const TrError = styled.tr`
  background-color: #ef5350;
  color: #fff;
  font-size: 12px;
`;

export const HorizontalContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
